// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* eslint-disable @typescript-eslint/no-explicit-any */
import produce from 'immer';
import { GET_LIST_KHIEU_NAI_DONE, GET_LIST_KHIEU_NAI_THEO_USER_DONE } from './constant';

export type DanhSachKhoHangState = {
  listKhieuNai: any;
  listKhieuNaiByUser: any;
};

const initState: DanhSachKhoHangState = {
  listKhieuNai: [],
  listKhieuNaiByUser: []
};

const cauHinhDiaChiReducer = (
  state = initState,
  action: ActionType,
): DanhSachKhoHangState => {
  return produce(
    state,
    (draftState: DanhSachKhoHangState): DanhSachKhoHangState => {
      switch (action.type) {
        case GET_LIST_KHIEU_NAI_DONE:
          draftState.listKhieuNai = action.payload;
          return draftState;
        case GET_LIST_KHIEU_NAI_THEO_USER_DONE:
          draftState.listKhieuNaiByUser = action.payload;
          return draftState;
        default:
          return draftState;
      }
    },
  );
};

export default cauHinhDiaChiReducer